/* eslint-disable max-lines-per-function */
import Headline from "../components/Headline.vue";
import Section from "../components/Section.vue";
import { List, ListItem } from "../components/List/index";
import "./PrintAsIs.scss";

export default function PrintAsIs({ onPrintPerfectClick, artwork, ...restProps }) {
  return (
    <>
      <Headline
        className="scope-a26b9902"
        slots={{
          title: () => <>For Pros who know.</>,
          subtitle: () => (
            <>
              {" "}
              You don't need our help. We print exactly as you send it, without any cutting edge,
              industry-leading print enhancements.{" "}
            </>
          )
        }}
        data-testid="headline"
      />
      <Section className="print-as-is__section scope-a26b9902" data-testid="print-as-is-section">
        <List className="scope-a26b9902" data-testid="list">
          <ListItem className="scope-a26b9902" kind="warning" data-testid="list-item">
            {"No"}
            <a
              className="scope-a26b9902"
              href="/jiffy-transfers-FAQs#transfer-quality-guarantee"
              target="_blank"
              data-testid="print-as-is-a"
            >
              {" "}
              PrintPerfect Guarantee{" "}
            </a>
          </ListItem>
          <ListItem className="scope-a26b9902" kind="warning" data-testid="list-item-1">
            {"No safety net"}
          </ListItem>
          <ListItem className="scope-a26b9902" kind="warning" data-testid="list-item-2">
            {"Quality depends on uploaded design"}
          </ListItem>
        </List>
      </Section>
    </>
  );
}
